"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateWidgets = void 0;
var widgets_1 = require("../private/services/widgets/widgets");
Object.defineProperty(exports, "PrivateWidgets", { enumerable: true, get: function () { return widgets_1.PrivateWidgets; } });
//# sourceMappingURL=index.js.map